import { AbstractCameraRig } from "./AbstractCameraRig";
/**
 * Controls the zoom-out camera transition for the scatter pick outro.
 */
export class ScatterPickOutroCameraRig extends AbstractCameraRig {
    create() {
        super.create();
        this.progress = 0;
    }
    handleRotate(event) {
        super.handleRotate(event);
        this.recentreFocus();
        this.applyZoom();
    }
    async playOutro() {
        this.progress = 0;
        this.applyZoom();
        this.zoomTween = gsap.to(this, {
            delay: 0.1,
            progress: 1,
            duration: 2,
            ease: "power1.inOut",
            onUpdate: () => this.applyZoom(),
        });
        await this.zoomTween;
    }
    applyZoom() {
        const zoomScale = this.uiProperties.scatterPickZoomEnd + (1 - this.uiProperties.scatterPickZoomEnd) * this.progress;
        this.scale.set(zoomScale);
    }
}
//# sourceMappingURL=ScatterPickOutroCameraRig.js.map